import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: any = []
const vesselSlice = createSlice({
  name: 'vessel',
  initialState,
  reducers: {
    updateVessel: (state: any, action: PayloadAction<any>) => {
      return action.payload
    },
  },
})
export const vesselAction = vesselSlice.actions
export default vesselSlice
